import React from 'react';
import { View, Text, Animated, Easing } from 'react-native';
import { Icon } from 'react-native-elements';
import { connect } from 'react-redux';
import { predict } from '../redux/actions'
import Hint from './hint'
import TextZ from './TextZ';

const resultChar = c => {
    switch (c) {
        case 'W':
        case 'X': return '?';
    }

    return c;
}
const resultText = c => {
    switch (c) {
        case 'W': return 'กำลังคำนวณ...'
        case 'X': return 'รอเข้าสูตร';
        case 'P': return 'Player';
        case 'B': return 'Banker';
    }

    return c
}

const resultColor = c => {
    switch (c) {
        case 'B': return "rgb(255,51,0)"
        case 'P': return "rgb(51, 102, 255)"
        case 'T': return "rgb(51, 204, 51)"
        case 'W': return '#FFD800'
        case 'X': return '#A26700';
    }
    return '#777777'
}

const predictStyle = (p) => {
    switch(p) {
        case 'B':
        case 'P':
        case 'T':
            return { backgroundColor: resultColor(p) }
        case 'X':
            return {
                borderColor: '#FFD800',
                borderWidth: 8,
                borderStyle: 'dashed',
            }
            
    }

    return {
        borderColor: '#FFD800',
        borderWidth: 8,
        borderStyle: 'dashed',
    }
}

class Component extends React.Component {
    constructor() {
        super()
        this.spinValue = new Animated.Value(0)
        this.spinning = null
        this.isSpin = false
    }

    spin = () => {
        if (this.isSpin) {
            console.log('already spin, ignore')
            return;
        }

        // console.log('start spin')

        this.spinValue.setValue(0)

        this.isSpin = true;
        this.spinning = Animated.timing(
            this.spinValue,
            {
                toValue: 1,
                duration: 3000,
                easing: Easing.linear
            }
        )
        
        this.spinning.start(({ finished }) => { 
            if (this.isSpin) { 
                this.isSpin = false;
                this.spin() 
            } 
        });
    }

    stop = () => {
        // console.log('stop spin')
        this.isSpin = false;
        this.spinValue.setValue(0)

        if (this.spinning) {
            this.spinning.stop()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.nextGame != prevProps.nextGame  && this.props.predict[this.props.nextGame] === 'W') {
                this.props.doPredict( this.props.predictor, this.props.moneyplan, this.props.gameState)
                this.spin()
        }

        if (this.isSpin && this.props.predict[this.props.nextGame] !== 'W') {
            this.stop()
        }
    }

    render() {
        const predict = this.props.predict[this.props.nextGame] || 'W';
        const money = this.props.money[this.props.nextGame] || '0';
        
        const spin = this.spinValue.interpolate({
            inputRange: [0, 1],
            outputRange: ['0deg', '360deg']
        })

        let hintText = '';
        if (predict === 'X') {
            if (this.props.gameState.results.length <= 3) {
                hintText = "กดใส่ผลอย่างน้อย 4 ตัวท้าย"
            } else 
            if (this.props.predictor === 'basic') {
                hintText = `กรุณารอตาหน้า หรือใช้สูตร VIP ที่แม่นยำกว่า`
            } else {
                hintText = `กรุณารอตาหน้า...`
            }
        }

        return <View style={{
            flexDirection: 'row',
            backgroundColor: 'rgba(0,0,0,0.5)'
        }}>
            <View style={{
                flexDirection: 'column',
                flex: 0.7,
                alignItems: 'center'
            }}>
                <TextZ style={{
                    textAlign: "center",
                    borderColor: "gold",
                    color: "gold",
                    borderWidth: 1,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    paddingHorizontal: 10,
                    paddingVertical: 5,
                    borderRadius: 10,
                    flex: 0,
                }}>ตาต่อไปแทง</TextZ>
 
                <View style={{
                    ...predictStyle(predict),
                    width: 120,
                    height: 120,
                    borderRadius: 60,
                    justifyContent: 'center',
                    marginTop: 5,
                }}>
                    <Animated.View style={{
                        transform: [{rotate: spin}],
                    }} >
                        {predict === 'W' ? 
                        <Icon name='spinner' type='font-awesome' color='#ffffff' />
                        : <TextZ style={{
                                fontSize: 50,
                                textAlign: "center",
                                fontWeight: "bold",
                                color: "#ffffff"
                            }}>{resultChar(predict)}</TextZ>}
                    </Animated.View>
                    <TextZ style={{
                        textAlign: "center",
                        color: "#ffffff"
                    }}>{resultText(predict)}</TextZ>
                </View>
                <TextZ style={{
                        textAlign: "center",
                        color: "#ffffff"
                }}>{hintText}</TextZ>

            </View>
            <View style={{
                flexDirection: 'column',
                flex: 0.3,
                alignContent: 'center',
                alignItems: 'center',
               justifyContent: "center"
            }}>
                <TextZ style={{
                    textAlign: "center",
                    borderColor: "gold",
                    color: "gold",
                    borderWidth: 1,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    paddingHorizontal: 10,
                    paddingVertical: 5,
                    borderRadius: 10,
                    flex: 0,             
                }}>จำนวนทบ</TextZ>
                <TextZ style={{
                    fontSize: 30,
                    color: "gold",
                    fontWeight: "bold"
                }}>x{money}</TextZ>
            </View>
        </View>
    }
}


const mapStateToProps = state => {
    return {
        gameState: state.results,
        money: state.results.money,
        predict: state.results.predict,
        nextGame: state.results.nextGame,
        predictor: state.settings.predictor,
        moneyplan: state.settings.moneyplan,
    };
};

const mapDispatchToProps = dispatch => {
    return {
      doPredict: (p, m, r) => dispatch(predict(p, m, r)),
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(Component);

 